import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'
import { storeInCache } from '../../modules/cache'

export interface LvcProfileDesktopScreenContent {}

Locale.getInstance().registerKeySet('fr', 'profileMenu', {
  logout: 'Me déconnecter',
  tabs: {
    profile: 'Profil',
    parameters: 'Paramètres',
  },
  links: {
    termsOfUse: "Conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    dataSharingPolicy: 'Politique de partage des données',
  },
})

Locale.getInstance().registerKeySet('en', 'profileMenu', {
  logout: 'Sign out',
  tabs: {
    profile: 'Profile',
    parameters: 'Parameters',
  },
  links: {
    termsOfUse: 'Terms of use',
    privacyPolicy: 'Privacy policy',
    dataSharingPolicy: 'Data sharing policy',
  },
})

export class LvcProfileDesktopScreenContent extends MinzeElement {
  reactive: Reactive = [['activeTab', 0]]

  openProfileCulture = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileCulture)
  }

  openProfileFavorites = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileFavorites)
  }

  openProfilePersonal = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profilePersonal)
  }

  openProfileNotification = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileNotification)
  }

  openProfileSecurity = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileSecurity)
  }

  handleLogout = () => {
    const mainModule = MainModule.getInstance()
    storeInCache('shouldGoToLastPage', true, 10000)
    mainModule.getAuth().logout()
    //@TODO handle redirect to home/last link (not profile)
    mainModule.hideModal(MODALS.PROFILE_MODAL)
  }

  onTabButtonClick(event: any): void {
    let tabId = event?.target?.getAttribute('data-tab-id')
    if (tabId) {
      this.activeTab = Number(tabId)
    }
  }

  html = () => {
    return `
			<h2>${Locale.getKey('profile.title')}</h2>
			<div class="form">
				<div class="profile-menu-tabs">
					<button id="profile-tab-button" data-tab-id="0" class="profile-menu-tab-button ${this.activeTab === 0 ? 'active' : ''}">
						${Locale.getKey('profileMenu.tabs.profile')}
					</button>
					<button id="parameters-tab-button" data-tab-id="1" class="profile-menu-tab-button ${this.activeTab === 1 ? 'active' : ''}">
						${Locale.getKey('profileMenu.tabs.parameters')}
					</button>
				</div>
				<div class="profile-items">
					${
            this.activeTab === 0
              ? `
						<lvc-button width="332px" height="168px" border-radius="12px" theme="transparent" padding="24px" class="tile" id="btn-profile-culture">
							<lvc-box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" columnGap="8px" rowGap="24px" color="#1E007D">
								<lvc-ticket-icon class="icon" data-width="48px" data-height="48px"></lvc-ticket-icon>
								<lvc-text width="100%" text-align="left" font-preset="largeExtraBold" line-height="120%" text-transform="uppercase">
									${Locale.getKey('profile.culture')}
								</lvc-text>
							</lvc-box>
						</lvc-button>
						<lvc-button width="332px" height="168px" border-radius="12px" theme="transparent" padding="24px" class="tile" id="btn-profile-favorites">
							<lvc-box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" columnGap="8px" rowGap="24px" color="#1E007D">
								<lvc-favorite-icon class="icon" data-width="48px" data-height="48px"></lvc-favorite-icon>
								<lvc-text width="100%" text-align="left" font-preset="largeExtraBold" line-height="120%" text-transform="uppercase">
									${Locale.getKey('profile.favorites')}
								</lvc-text>
							</lvc-box>
						</lvc-button>
					`
              : ''
          }
					${
            this.activeTab === 1
              ? `
						<lvc-button  width="332px" height="168px" border-radius="12px" theme="transparent" padding="24px" class="tile" id="btn-profile-security" >
							<lvc-box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" columnGap="8px" rowGap="24px" color="#1E007D">
								<lvc-key-icon class="icon" data-width="48px" data-height="48px"></lvc-key-icon>
								<lvc-text width="100%" text-align="left" font-preset="largeExtraBold" line-height="120%" text-transform="uppercase">
									${Locale.getKey('profile.security')}
								</lvc-text>
							</lvc-box>
						</lvc-button>
						<lvc-button  width="332px" height="168px" border-radius="12px" theme="transparent" padding="24px" class="tile" id="btn-profile-personal">
							<lvc-box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" columnGap="8px" rowGap="24px" color="#1E007D">
								<lvc-person-icon class="icon" data-width="48px" data-height="48px"></lvc-person-icon>
								<lvc-text width="100%" text-align="left" font-preset="largeExtraBold" line-height="120%" text-transform="uppercase">
									${Locale.getKey('profile.personal')}
								</lvc-text>
							</lvc-box>
						</lvc-button>
						<lvc-button  width="332px" height="168px" border-radius="12px" theme="transparent" padding="24px" class="tile" id="btn-profile-notification">
							<lvc-box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" columnGap="8px" rowGap="24px" color="#1E007D">
								<lvc-notification-icon class="icon" data-width="48px" data-height="48px"></lvc-notification-icon>
								<lvc-text width="100%" text-align="left" font-preset="largeExtraBold" line-height="120%" text-transform="uppercase">
									${Locale.getKey('profile.notification')}
								</lvc-text>
							</lvc-box>
						</lvc-button>
					`
              : ''
          }
				</div>
				<div class="links-container">
					<a class="link" href=${MainModule.getInstance().getRouting().getRoute('termsOfUse')} target="_blank">${Locale.getKey('profileMenu.links.termsOfUse')}</a>
					<a class="link" href=${MainModule.getInstance().getRouting().getRoute('privacyPolicy')} target="_blank">${Locale.getKey('profileMenu.links.privacyPolicy')}</a>
					<a class="link" href=${MainModule.getInstance().getRouting().getRoute('dataSharingPolicy')} target="_blank">${Locale.getKey('profileMenu.links.dataSharingPolicy')}</a>
				</div>

				<lvc-button theme="dark" id="btn-logout" width="fit-content" padding="14px 24px" font-size="14px" font-weight="500" enable-hover-box-shadow="true">
					${Locale.getKey('profileMenu.logout')}
				</lvc-button>

				<lvc-charlie-waving-icon></lvc-charlie-waving-icon>
			</div>
		`
  }

  css = () => {
    return `
			:host {
				max-width: 1040px;
				margin: 0 auto;
			}
			.tile {
				transition: transform 0.2s ease-in-out;
				backface-visibility: hidden;
				background-image: url("data:image/svg+xml,%3Csvg width='332' height='168' viewBox='0 0 332 170' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176.035 168.94C215.905 169.351 280.732 167.549 317.272 166.291C323.87 166.064 328.989 160.531 328.988 153.929C328.985 130.188 331 107.677 331 79.75C331 50.6732 329.699 34.8338 329.294 13.9482C329.164 7.24986 323.696 1.84695 316.997 1.93178C274.325 2.47209 194.612 3.01178 168.604 1.7626C142.138 0.491455 63.5717 1.07263 14.0044 1.62192C7.30286 1.69618 1.99524 7.25038 2.12094 13.9511C2.67352 43.407 2.33087 73.1544 1.52942 82.375C0.820648 90.5294 0.864166 132.645 1.41882 154.901C1.57379 161.12 6.58176 165.965 12.8008 166.093C56.1058 166.988 135.108 168.519 176.035 168.94Z' stroke='%231E007D' stroke-width='2'/%3E%3C/svg%3E");
			}

			.tile:hover {
				transform: scale(1.08);
			}

			.form {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				row-gap: 24px;
			}
			.profile-items {
				min-width: 100%;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				justify-content: flex-start;
				gap: 16px;
			}
			.links-container {
				text-align: center;
				margin: 16px 0;
			}
			.link {
				color: #1E007D;
				font-weight: ${Font.weight.medium};
				font-size: 14px;
				line-height: 120%;
				text-decoration: underline;
				margin: 0;
				margin-right: 8px;
				margin-left: 8px;
				cursor: pointer;
			}
			lvc-charlie-waving-icon {
				position: fixed;
				right: 46px;
				bottom: 0;
				height: 262px;
				pointer-events: none;
			}
			.profile-menu-tabs {
				width: 100%;
				border-bottom: 1px solid #1E007D;
				display: flex;
				grid-column-gap: 2.5rem;
			}
			.profile-menu-tab-button {
				border: none;
				background: transparent;
				padding: 9px 0 8px 0;
				color: #1E007D;
				font-size: 14px;
				font-style: normal;
				font-weight: 500;
				border-bottom: 4px solid transparent;
				cursor: pointer;
				font-family: inherit;
				border-bottom: 4px solid transparent;
				transition: all 0.2s;
			}
			.profile-menu-tab-button.active {
				border-bottom: 4px solid #1E007D;
			}
			.profile-menu-tab-button.active:hover {
				border-bottom: 4px solid #1E007D;
			}
			.profile-menu-tab-button:hover {
				border-bottom: 4px solid rgba(30, 0, 125, 0.2);
			}
			h2 {
				font-size: 60px;
				font-style: normal;
				font-weight: 800;
				line-height: 100%;
				margin: 40px 0;
				color: #1E007D;
			}
		`
  }

  eventListeners: EventListeners = [
    ['#btn-profile-culture', 'click', this.openProfileCulture.bind(this)],
    ['#btn-profile-personal', 'click', this.openProfilePersonal.bind(this)],
    ['#btn-profile-notification', 'click', this.openProfileNotification.bind(this)],
    ['#btn-profile-favorites', 'click', this.openProfileFavorites.bind(this)],
    ['#btn-profile-security', 'click', this.openProfileSecurity.bind(this)],
    ['#btn-logout', 'click', this.handleLogout.bind(this)],
    ['.profile-menu-tab-button', 'click', this.onTabButtonClick.bind(this)],
  ]
}
